import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/web"
import Notifications from '@kyvg/vue3-notification'
import {TooltipDirective} from "@/directives/tooltip";
import i18n from "@/i18n";
const app = createApp(App)

app.directive('v-tooltip',TooltipDirective)
app.use(router)
app.use(i18n)
app.use(Notifications)
app.mount('#app')
